import {getMatterDocumentIdOrder} from "./get_matter_file_names";

// When clauses come from multiple source docs (matter), assigns each doc a
// file_index so the applicable clauses file selector can group clauses by source doc.
function buildMatterFileIndexMap(applicableClauses) {
  const docIds = getMatterDocumentIdOrder(applicableClauses);
  return docIds.length > 1 ? new Map(docIds.map((id, i) => [id, i + 1])) : null;
}

export default function calculateClauses(
  issue,
  documentClauseparts,
  _applicableClauses,
  _relatedClauses,
  _relatedClausesCount,
) {
  const hasLlmResponse = issue.trigger_type === "LLM" && issue.llm_response;
  const matterFileIndices = buildMatterFileIndexMap(
    issue.llm_response?.applicable_clauses,
  );
  const generateEntries = (applicableClauses, filter) =>
    Object.fromEntries(
      Object.entries(issue.llm_response.applicable_clauses ?? {}).map(
        ([topic, clauses]) => [
          topic,
          (Array.isArray(clauses) ? clauses : [])
            .filter(filter)
            .map(clause => {
              const documentClausepart = documentClauseparts.find(
                ({id}) => id === clause.id,
              );
              return {
                ...clause,
                text:
                  documentClausepart?.partial_text ?? clause.partial_text ?? "",
                reference: documentClausepart?.reference ?? "",
                file_index:
                  matterFileIndices?.get(clause.document_id) ??
                  clause.file_index,
                // Markdown syntax is supported for applicable clauses
                // sourced from the mock LLM response field
                isMarkdown: true,
              };
            })
            .sort((a, b) => a.id - b.id),
        ],
      ),
    );
  const applicableClauses = hasLlmResponse
    ? generateEntries(issue, clause => (clause?.score ?? 5) >= 4)
    : _applicableClauses;
  const relatedClauses = hasLlmResponse
    ? generateEntries(issue, clause => (clause?.score ?? 5) === 3)
    : _relatedClauses;
  const relatedClausesCount = hasLlmResponse
    ? relatedClauses?.All?.length
    : _relatedClausesCount;
  return {
    applicableClauses,
    relatedClauses,
    relatedClausesCount,
  };
}
